const hero = {
    init() {
        $(document).ready(function() {
            $('.hero-carousel').slick({
                dots: true,
                infinite: false,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                appendDots: $('.hero'),
                arrows: false,
            });

            $('.hero-slider').next('div').attr('id', 'first-section');
        });

        $(document).ready(function() {
            function calculateScrollPosition() {
              var navbarHeight = $('.navbar').outerHeight();
              var firstSectionTop = $('#first-section').offset().top;
              var adjustedScrollPosition = firstSectionTop - navbarHeight;
              return adjustedScrollPosition;
            }

            // Smooth scroll when 'page-down-link' is clicked
            $('.page-down-link').on('click', function(e) {
              e.preventDefault();

              var scrollPosition = calculateScrollPosition();

              $('html, body').animate({
                scrollTop: scrollPosition,
              }, 500);
            });
        });
    },
};

export default hero;



// WEBPACK FOOTER //
// ./scripts/blocks/hero.js